module.exports = __webpack_public_path__ + "static/media/autocarrier.59386340.png";